import cxs from 'cxs';

export const EMPTY_DATA = cxs({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column'
});